module.exports = __webpack_public_path__ + "img/error-503.62fd6b0e.svg";